module.exports = __webpack_public_path__ + "img/m-banner-fmugwkfb-ru-RU.5ff54897.png";